
import WOW from "../../public/statics/ll/js/wow";

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper";

import "swiper/swiper-bundle.min.css";

import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";

import $ from "jquery";
import moment from "moment";
import Vue, { onMounted, watch } from "vue";
import {
  ref,
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
} from "vue";
import {
  technologicalFrontierData,
  getArticleByCategoryId,
  getBannerByPosition,
} from "../views/api/user";
import router from "@/router";
import { inject } from "vue";
export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {};
  },

  setup() {
    //获取全局变量
    // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      let num=ref("01")
    let proxy = getCurrentInstance() as any;
  let show = ref<any>(true);
    //全局url
    const url = proxy.appContext.config.globalProperties.$url;
    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
  if (lan == "EN") {
      show.value = false;
    } else {
      show.value = true;
    }
    let research = ref([]);
    let scienceDataArray =ref([]);
    let AboutUS = ref([]);
    let banner = ref([]);
    const refresh = inject<any>("reload");
    let internationalCooperationData = ref([]);
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };

    //获取banner图
    const getBanner = async () => {
      if (lan == "EN") {
        const code = reactive({
          position: "15",
        });
        const res = await getBannerByPosition.getData(code);
        banner.value = res.data.result;
        console.log("banner", banner);
      } else {
        const code = reactive({
          position: "14",
        });
        const res = await getBannerByPosition.getData(code);
        banner.value = res.data.result;
        console.log("banner", banner);
      }
    };

    //获取研究与创新数据
    const getResearch = async () => {
      if (lan == "EN") {
        let column = reactive({
          categoryId: 289505288237381,
        });
        const res = await getArticleByCategoryId.getData(column);
        research.value = res.data.result;
        console.log("research", research);
      } else {
        let column = reactive({
          categoryId: 279239987921221,
        });
        const res = await getArticleByCategoryId.getData(column);
        research.value = res.data.result;
        console.log("research", research);
      }
    };
// const aa=( )=>{
//   var bb=0
//   var cc:any = document.getElementById("b");
//  bb= cc.getAttribute('index')
//  bb=Number(bb)
// bb+=1
// if(bb==0){
// num.value="01"
// }else if(bb==1){
// num.value="02"
// }else if(bb==3||bb==4){
//   num.value="03"
// }

//  console.log("cc",bb)


// }

  //跳转文章
    const goLink = (No, id, title, title2) => {
      if (No == 1) {
          router.push({
          path: "/aboutUs" ,
        });
      } else if (No == 2) {
        router.push({
          path: "/researchInnovation" ,
        });
      } else if (No == 3){
        scienceDataArray.value.forEach((item:any,index)  => {
          if(item.name==title){ //将absorbData值保存到本地
        window.sessionStorage.setItem(
          "absorbData",
          JSON.stringify(item.article)
        );

          }
        });
       

              if (lan == "EN") {
        let name = "Latest Research";
        router.push({
          path: "/article/" + id + "/" + name + "/" + title + "/" + false,
        });
      } else {
        let name = "科技前沿";
        router.push({
          path: "/article/" + id + "/" + name + "/" + title + "/" + false,
        });
      }
      }else if(No==5){
        console.log("id",id)
  router.push({
          path: "/"+id
        });

      }

    };









    //获取关于我们数据
    const getAboutUs = async () => {
      if (lan == "EN") {
        let column = reactive({
          categoryId: 289505612538181,
        });

        const res = await getArticleByCategoryId.getData(column);
        console.log("getAboutUs", res);
        AboutUS.value = res.data.result;
        console.log("AboutUS", AboutUS);
      } else {
        let column = reactive({
          categoryId: 279238138237253,
        });
        const res = await getArticleByCategoryId.getData(column);
        console.log("getAboutUs", res);
        AboutUS.value = res.data.result;
        console.log("AboutUS", AboutUS);
      }
    };

    //获取科技研究数据
    const getScienceData = async () => {
      if (lan == "EN") {
        let IsEn = {
          IsEn: true,
        };

        const res = await technologicalFrontierData.getData(IsEn);
        console.log("aa", res);
        scienceDataArray.value= res.data.result;
        console.log("scienceDataArray", scienceDataArray);
      } else {
        let IsEn = {
          IsEn: false,
        };

        const res = await technologicalFrontierData.getData(IsEn);
        console.log("aa", res);
        scienceDataArray.value= res.data.result;
        console.log("scienceDataArray", scienceDataArray);
      }
    };

    //获取国际合作数据

    const internationalCooperation = async () => {
      if (lan == "EN") {
        const column = reactive({
          categoryId: 289547676836165,
        });
        const res = await getArticleByCategoryId.getData(column);
        console.log("getAboutUs", res);
        internationalCooperationData.value = res.data.result;
        console.log(
          "internationalCooperationData",
          internationalCooperationData
        );
      } else {
        const column = reactive({
          categoryId: 279283652706629,
        });
        const res = await getArticleByCategoryId.getData(column);
        console.log("getAboutUs", res);
        internationalCooperationData.value = res.data.result;
        console.log(
          "internationalCooperationData",
          internationalCooperationData
        );
      }
    };

    // //菜单切换
    // $(document).ready(function () {
    //   $("#flip").click(function () {
    //     $("#panel").slideToggle("slow");
    //   });
    // });



    //判断浏览器的屏幕
    function redirectPage() {
      var wjb51 = screen.width;

      if (wjb51 <= 450) {
        $(".center-title").removeClass("wow slideInUp");
        $(".center-top-content-left").removeClass(
          "wow bounceInLeft bg-green  animated"
        );
        $(".center-top-content-right").removeClass(
          "wow bounceInRight bg-yellow  animated"
        );
        $(".center-btn-t").removeClass("wow swing bg-purple animated");
        $(".center-bot-content-left").removeClass(
          "wow bounceInDown bg-green  animated"
        );
        $(".center-bot-content-middle2 h4").removeClass(
          "wow bounceInLeft bg-green  animated"
        );
        $(".center-bot-content-middle-p").removeClass(
          "wow bounceInLeft bg-green   animated"
        );
        $(".center-bot-content-middle3").removeClass(
          "wow lightSpeedIn bg-purple  animated"
        );
      }
    }

    onMounted(() => {
      // handleLogin();
      getScienceData();
      getAboutUs();
      getResearch();
      getBanner();
      internationalCooperation();
      //卡片
      $(function () {
        var sumgs =1 //div的总个数
        console.log("sumgs",sumgs)
        var sum = 0; //总页数
        var jdtlen; //进度条点击之后的长度
        var djlen = 1; //数字
        $(".slider-nav-page").text("0" + djlen);
        sum = String(sumgs / 4).indexOf(".") + 1; //获取小数点的位置
        var count = String(sumgs / 4).length - sum; //获取小数点后的个数
        if (sum > 0) {
          //判断是否有小数
          sum++;
        } else {
          sum = sumgs / 4;
          jdtlen = 160 / sum;
        }
        $(".slider-nav-total").text("0" + sum);
        var gblen = djlen;
        $(".slider-progress-inner").animate(
          {
            width: 160 / sum + "px",
          },
          1000
        );
        $(".slider-nav-item-next").click(function () {
          if (gblen == sum) {
            gblen = 1;
            $(".slider-nav-page").text("0" + gblen);
          } else {
            ++gblen;
            $(".slider-nav-page").text("0" + gblen);
          }
          $(".slider-progress-inner").animate(
            {
              width: (160 / sum) * gblen + "px",
            },
            1000
          );
        });
        $(".slider-nav-item-prev").click(function () {
          if (gblen <= 1) {
            gblen = sum;
            $(".slider-nav-page").text("0" + gblen);
          } else {
            --gblen;
            $(".slider-nav-page").text("0" + gblen);
          }
          $(".slider-progress-inner").animate(
            {
              width: (160 / sum) * gblen + "px",
            },
            1000
          );
        });
      });

      // WOW.init();
      //切换
      $(function () {
        /*======next======*/
        $(".next").click(function () {
          nextscroll();
        });

        function nextscroll() {
          var vcon = $(".v_cont ");
          var offset = $(".v_cont li").width() * -1;
          console.log("offset", offset);
          vcon.stop().animate(
            {
              left: offset,
            },
            "slow",
            function () {
              var firstItem = $(".v_cont ul li").first();
              vcon.find("ul").append(firstItem);
              vcon.css("left", "0px");
              circle();
            }
          );
        }

        function circle() {
          var currentItem = $(".v_cont ul li").first();
          var currentIndex = currentItem.attr("index");
          $(".circle li").removeClass("circle-cur");
          $(".circle li").eq(currentIndex).addClass("circle-cur");
        }

        //setInterval(nextscroll,2000)

        /*======prev======*/

        $(".prev").click(function () {
          var vcon = $(".v_cont ");
          var offset = $(".v_cont li").width() * -1;
          console.log("offset", offset);
          var lastItem = $(".v_cont ul li").last();
          vcon.find("ul").prepend(lastItem);
          vcon.css("left", offset);
          vcon.animate(
            {
              left: "0px",
            },
            "slow",
            function () {
              circle();
            }
          );
        });

        /*======btn====circle======*/

        var animateEnd = 1;
        $(".circle li").click(function () {
          if (animateEnd == 0) {
            return;
          }
          $(".circle li")
            .addClass("circle-cur")
            .siblings()
            .removeClass("circle-cur");
          var nextindex = $(".circle li").index();
          var currentindex = $(".v_cont li").first().attr("index");
          var curr = $(".v_cont li").first().clone();
          if (nextindex > currentindex) {
            for (var i = 0; i < nextindex - currentindex; i++) {
              var firstItem = $(".v_cont li").first();
              $(".v_cont ul").append(firstItem);
            }
            $(".v_cont ul").prepend(curr);
            var offset = $(".v_cont li").width() * -1;
            if (animateEnd == 1) {
              animateEnd = 0;
              $(".v_cont")
                .stop()
                .animate(
                  {
                    left: offset,
                  },
                  "slow",
                  function () {
                    $(".v_cont ul li").first().remove();
                    $(".v_cont").css("left", "0px");
                    animateEnd = 1;
                  }
                );
            }
          } else {
            var curt = $(".v_cont li").last().clone();
            for (var ii = 0; ii < currentindex - nextindex; ii++) {
              var lastItem = $(".v_cont li").last();
              $(".v_cont ul").prepend(lastItem);
            }
            $(".v_cont ul").append(curt);
            var offset1 = $(".v_cont li").width() * -1;
            $(".v_cont").css("left", offset1);
            if (animateEnd == 1) {
              animateEnd = 0;
              $(".v_cont")
                .stop()
                .animate(
                  {
                    left: "0px",
                  },
                  "slow",
                  function () {
                    $(".v_cont ul li").last().remove();
                    animateEnd = 1;
                  }
                );
            }
          }
        });
      });

      redirectPage();
    });

    return {
      // ...toRefs(state),
      // handleLogin,
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
      getScienceData,
      getAboutUs,
      getResearch,
      getBanner,
      goLink,
      refresh,
      internationalCooperation,
      banner,
      AboutUS,
      show,
      proxy,
      url,
      // aa,
      num,
      research,
      scienceDataArray,
      moment,
      internationalCooperationData,
    };
  },
});
